export default __webpack_public_path__ + "static/media/2.cfa382e5.png";